import { render, staticRenderFns } from "./copyswitch.vue?vue&type=template&id=0214a8c0&"
import script from "./copyswitch.vue?vue&type=script&lang=ts&"
export * from "./copyswitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copyswitch.vue"
export default component.exports